import { Button, Card, Typography } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import {
  generateCodeVerifier,
  generateCodeChallenge,
  generateState,
  saveCodeVerifier,
} from "@utils/PkceUtils";

const { Title, Text } = Typography;

const ZALO_APP_ID = (process.env as any).ZALO_APP_ID || "YOUR_ZALO_APP_ID";
const ZALO_REDIRECT_URI = `${window.location.origin}/callback/login/zalo-web`;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleZaloLogin = () => {
    const codeVerifier = generateCodeVerifier();
    const codeChallenge = generateCodeChallenge(codeVerifier);
    const state = generateState();

    saveCodeVerifier(state, codeVerifier);

    const redirectUri = encodeURIComponent(ZALO_REDIRECT_URI);
    const encodedCodeChallenge = encodeURIComponent(codeChallenge);
    const encodedState = encodeURIComponent(state);

    const zaloLoginUrl = `https://oauth.zaloapp.com/v4/permission?app_id=${ZALO_APP_ID}&redirect_uri=${redirectUri}&code_challenge=${encodedCodeChallenge}&code_challenge_method=S256&state=${encodedState}`;

    window.location.href = zaloLoginUrl;
  };

  const handleFMSLogin = async () => {
    setLoading(true);
  };

  return (
    <Container className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
            <img src={"/images/logo-bg-white.jpg"} alt="Sổ tay 01" />
          </div>
          <Title level={2} className="mb-2">
            Chào mừng đến với Sổ tay 01
          </Title>
          <Text type="secondary" className="text-base">
            Đăng nhập để truy cập hệ thống
          </Text>
        </div>

        <div className="space-y-4">
          <Button
            size="large"
            loading={loading}
            onClick={handleZaloLogin}
            className="w-full h-14 rounded-lg bg-[#0573ff] hover:bg-[#0573ff] border-none text-base font-medium text-white flex items-center justify-center zalo-login-button"
            style={{
              backgroundColor: "#0573ff",
              color: "#fff",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="100"
              height="100"
              viewBox="0 0 48 48"
            >
              <path
                fill="#2962ff"
                d="M15,36V6.827l-1.211-0.811C8.64,8.083,5,13.112,5,19v10c0,7.732,6.268,14,14,14h10	c4.722,0,8.883-2.348,11.417-5.931V36H15z"
              ></path>
              <path
                fill="#eee"
                d="M29,5H19c-1.845,0-3.601,0.366-5.214,1.014C10.453,9.25,8,14.528,8,19	c0,6.771,0.936,10.735,3.712,14.607c0.216,0.301,0.357,0.653,0.376,1.022c0.043,0.835-0.129,2.365-1.634,3.742	c-0.162,0.148-0.059,0.419,0.16,0.428c0.942,0.041,2.843-0.014,4.797-0.877c0.557-0.246,1.191-0.203,1.729,0.083	C20.453,39.764,24.333,40,28,40c4.676,0,9.339-1.04,12.417-2.916C42.038,34.799,43,32.014,43,29V19C43,11.268,36.732,5,29,5z"
              ></path>
              <path
                fill="#2962ff"
                d="M36.75,27C34.683,27,33,25.317,33,23.25s1.683-3.75,3.75-3.75s3.75,1.683,3.75,3.75	S38.817,27,36.75,27z M36.75,21c-1.24,0-2.25,1.01-2.25,2.25s1.01,2.25,2.25,2.25S39,24.49,39,23.25S37.99,21,36.75,21z"
              ></path>
              <path
                fill="#2962ff"
                d="M31.5,27h-1c-0.276,0-0.5-0.224-0.5-0.5V18h1.5V27z"
              ></path>
              <path
                fill="#2962ff"
                d="M27,19.75v0.519c-0.629-0.476-1.403-0.769-2.25-0.769c-2.067,0-3.75,1.683-3.75,3.75	S22.683,27,24.75,27c0.847,0,1.621-0.293,2.25-0.769V26.5c0,0.276,0.224,0.5,0.5,0.5h1v-7.25H27z M24.75,25.5	c-1.24,0-2.25-1.01-2.25-2.25S23.51,21,24.75,21S27,22.01,27,23.25S25.99,25.5,24.75,25.5z"
              ></path>
              <path
                fill="#2962ff"
                d="M21.25,18h-8v1.5h5.321L13,26h0.026c-0.163,0.211-0.276,0.463-0.276,0.75V27h7.5	c0.276,0,0.5-0.224,0.5-0.5v-1h-5.321L21,19h-0.026c0.163-0.211,0.276-0.463,0.276-0.75V18z"
              ></path>
            </svg>
            {loading ? "Đang đăng nhập..." : "Đăng nhập với Zalo"}
          </Button>
        </div>
      </Card>
    </Container>
  );
};

const Container = styled.div`
  .zalo-login-button svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    fill: #fff;
  }
`;

export default Login;
